import videojs from '@mux/videojs-kit/dist/index.vhs.js';

window.pixelsjs = videojs;